import { VStack } from "components/ui/containers/stacks";
import { BluePanelTitle, RegularText } from "components/ui/texts";
import { useContext } from "react";
import { ModalContext } from "components/ui/modal";
import {
  createAuthUserWithEmailAndPasswordByAdmin,
  createUserDocFromAuth,
} from "utils/firebase/firebase.utils";
import { FirebaseUserGateway } from "utils/firebase/firebase.user";
import { FilledButton } from "components/ui/buttons";
import { UserInfos } from "types/user.types";
import { H4 } from "components/ui/headings";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Panel } from "components/ui/cards";
import styled from "styled-components";

const USER_ID = "dvU9oe8I8xQ4RzvzrMyE98XzA6u1";
const PASSWORD = "password";
const EMAIL = "mc.daroux@wanadoo.fr";

export const CreateMemberFromMemberWithNoAuth = () => {
  const { handleModal } = useContext(ModalContext);

  type FormValues = {
    userId: string;
    email: string;
    password: string;
  };

  const initialValues: FormValues = {
    userId: "",
    email: "",
    password: "",
  };
  const validationSchema = Yup.object({
    userId: Yup.string().required("L'ID du membre est obligatoire"),

    email: Yup.string()
      .email("L'adresse email n'est pas valide")
      .required("L'email est obligatoire"),

    password: Yup.string()
      .min(6, "Le mot de passe doit contenir au moins 6 caractères")
      .required("Le mot de passe est obligatoire"),
  });

  const handleSubmit = async (values: FormValues) => {
    try {
      const userGateway = new FirebaseUserGateway();

      const userWithNoAuth = (await userGateway.getUserById(
        values.userId,
      )) as UserInfos;

      if (!userWithNoAuth) {
        alert("Aucun membre trouvé avec cet ID");
        return;
      }

      const { user } = await createAuthUserWithEmailAndPasswordByAdmin(
        values.email,
        values.password,
      );

      console.log("got user", user);

      await createUserDocFromAuth(user, {
        lastName: userWithNoAuth.lastName,
        firstName: userWithNoAuth.firstName,
        login: userWithNoAuth.login,
        email: values.email,
        landLineNumber: userWithNoAuth.landLineNumber,
        phoneNumber: userWithNoAuth.phoneNumber,
        civilAdress: userWithNoAuth.civilAdress,
        region: userWithNoAuth.region,
        diploma: userWithNoAuth.diploma,
        birthdate: userWithNoAuth.birthdate,
        grade: userWithNoAuth.grade,
        DATECEN: userWithNoAuth.DATECEN,
        DATE1LCL: userWithNoAuth.DATE1LCL,
        DATE2CL: userWithNoAuth.DATE2CL,
        brigade: userWithNoAuth.brigade,
        army: userWithNoAuth.army,
        originArmy: userWithNoAuth.originArmy,
        maritalSituation: userWithNoAuth.maritalSituation,
        children: userWithNoAuth.children,
        permanentAdress: userWithNoAuth.permanentAdress,
        repReunion: userWithNoAuth.repReunion,
        promotion: userWithNoAuth.promotion,
        cotisations: userWithNoAuth.cotisations,
        isDeceased: userWithNoAuth.isDeceased,
        deceasedData: userWithNoAuth.deceasedData,
      });
      alert("Utilisateur créé avec succès!");
      handleModal();
    } catch (error: any) {
      if (error.code === "auth/email-already-in-use") {
        alert("Email déjà utilisé");
      } else {
        console.error("Erreur lors de la création du membre :", error);
        alert("Une erreur est survenue lors de la création du membre");
      }
    }
  };
  return (
    <Panel>
      <VStack fullHeight justifyContent="space-between">
        <H4>Créer un membre avec un email existant</H4>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, dirty, isValid }) => (
            <Form>
              <VStack gap={20} style={{ marginTop: 20 }}>
                <InputWrapper>
                  <RegularText>avec l'id : {initialValues.userId}</RegularText>
                  <Field name="userId" type="text" style={{ padding: 8 }} />
                </InputWrapper>

                <InputWrapper>
                  <RegularText>et l'email : {initialValues.email}</RegularText>
                  <Field name="email" type="email" style={{ padding: 8 }} />
                </InputWrapper>

                <InputWrapper>
                  <RegularText>
                    en utilisant le mot de passe : {initialValues.password}
                  </RegularText>
                  <Field
                    name="password"
                    type="password"
                    style={{ padding: 8 }}
                  />
                </InputWrapper>

                <FilledButton
                  style={{ marginTop: 20 }}
                  type="submit"
                  buttonSize="small"
                  title={isSubmitting ? "Création..." : "Créer le membre"}
                  disabled={isSubmitting || !isValid || !dirty}
                  loading={isSubmitting}
                />
              </VStack>
            </Form>
          )}
        </Formik>
      </VStack>
    </Panel>
  );
};

const InputWrapper = styled(VStack)`
  gap: 5px;
`;
